import React from 'react';
import { wrap } from './style/title';

interface Props {
  title: string;
  totalRow: number;
  justifyContent?: string;
}

function Title({ title, totalRow, justifyContent = 'space-between' }: Props) {
  const numberFormatter = new Intl.NumberFormat('ko');

  return (
    <div css={wrap(justifyContent)}>
      <h2>{title} </h2>
      <p>
        총 <span>{numberFormatter.format(totalRow)}</span>개
      </p>
    </div>
  );
}

export default Title;
